import Vue from 'vue'

const apis = require.context('.',true,/\.js$/);
let allApiList = {};
apis.keys().forEach(key => {
  if(key !== './index.js'){
    allApiList = Object.assign(allApiList, apis(key).default);
  }
})
Vue.prototype.$api = allApiList;



// WEBPACK FOOTER //
// ./src/api/index.js